import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

interface IProps extends BoxProps {
    children: ReactNode;
}

export const DashboardContainer = (props: IProps) => {
    const { children, ...rest } = props;

    return (
        <Box
            display={"flex"}
            maxWidth={1750}
            marginX={"auto"}
            width={"100%"}
            {...rest}
        >
            {children}
        </Box>
    );
};
